<template>
	<div>
		<vxe-modal v-model="modal_model" :title="title" :width="modal_width" :height="modal_height" @show="modal_onshow"
			show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid  ref="configTable" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<list-index ref="listIndex" :row="currentrow" />	
				<!-- <config ref="config" :row="currentrow" /> -->	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listIndex from './list.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
			title: {
				default: () => {
					return '运费设置'
				}
			}
		},
		data() {
			return {
				modal_title: 'title',
				modal_width: 1000,
				modal_height: 800,
				currentrow:{},

				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'areaName',
						title: '适用地区',
					},
					{
						field: 'storageName',
						title: '仓库'
					},
					{
						field: 'otherdetail',
						title: '其他时段',
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.othertime(row)}}>其他时段</el-button>,
									// <el-button type = "text" size = "mini" onClick = {() => {this.del(row)}} style="color:#F56C6C">关闭本地配置</el-button>
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.parcel.listdetail({
						unitUid: this.row.unitUid
					}).then((res) => {
						resolve({
							list: res
						})
					})

				})
			},
			othertime(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.listIndex.modal_show()
				})
				
			},
			// del(row){
			// 	this.currentrow = row
			// 	this.$confirm('是否确认关闭?').then(()=>{
			// 		this.$api.parcel.delconfig({
			// 			basDistrFeeUid: row.basDistrFeeUid,
			// 		}).then(() => {
			// 			this.$refs.configTable.commitProxy('query')
			// 		})	
			// 	})			
			// },
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			listIndex
		}
	}
</script>